import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PoEditFormImpl from './PoEditFormImpl';
import PoList from './PoList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PoListView from './PoListView'


export default function PoDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.poDashboard);
  const [ poId, setPoId] = React.useState('');
  const [reloadPoList, setReloadPoList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PoEditFormImpl 
            setReloadPoList={setReloadPoList}
            poId={poId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PoListView 
                      setPoId = {setPoId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
